<template>
  <div>
    <!-- 其他费用 -->
    <myDialog
      :diaWidth="diaWidth_otherFee"
      :dialogTitle="dialogTitle_otherFee"
      :isShowDialog="isShowDialog_otherFee"
      confirmText="保存"
      @handleCloseDia="handleCloseDia_otherFee"
      @diaCancelBtn="handleCloseDia_otherFee"
      @diaConfirmBtn="diaConfirmBtn_otherFee"
    >
      <div>
        <div class="glo_dialogForm">
          <el-form
            v-if="isShowDialog_otherFee"
            class="diaForm"
            ref="dialogFormRef"
            :model="dialogForm"
            label-width="100px"
          >
            <el-form-item
              class="dialogFormItems"
              prop="itemCategoryId"
              label="费项类型:"
            >
              <el-select
                clearable
                filterable
                v-model="dialogForm.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryId"
              >
                <el-option
                  v-for="item in categoryNameList"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="itemCategoryId"
              label="费项:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogForm.itemServiceId"
                placeholder="请选择"
                @change="changeItemServiceId"
              >
                <el-option
                  v-for="item in CategoryServiceList"
                  :key="item.itemServiceId"
                  :label="item.title"
                  :value="item.itemServiceId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="dialogFormItems" prop="amount" label="金额:">
              <el-input
                type="number"
                v-model="dialogForm.amount"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dislogFormTextarea"
              prop="remarks"
              label="备注:"
            >
              <el-input
                type="textarea"
                rows="2"
                v-model="dialogForm.remarks"
              ></el-input>
            </el-form-item>
            <el-button class="glo_bgcMainColor" @click="confirmAdd()"
              >确认添加</el-button
            >
          </el-form>
        </div>
        <!-- 表格 -->
        <div class="glo_Table" style="margin-bottom: 20px">
          <el-table
            header-align="center"
            :data="tablerData"
            border
            stripe
            show-summary
            :highlight-current-row="true"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            >
            </el-table-column>
            <el-table-column
              label="费项类型"
              prop="itemCategoryName"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="费项"
              prop="itemServiceName"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="金额"
              prop="amount"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="备注"
              prop="remarks"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button class="rbtns" @click.stop="editFee(scope.$index)"
                    >编辑</el-button
                  >
                  <el-button class="rbtns" @click.stop="delBtns(scope.$index)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>

    <!-- 编辑 -->
    <myDialog
      :diaWidth="diaWidth_edit"
      :dialogTitle="dialogTitle_edit"
      :isShowDialog="isShowDialog_edit"
      confirmText="保存修改"
      @handleCloseDia="handleCloseDia_edit"
      @diaCancelBtn="handleCloseDia_edit"
      @diaConfirmBtn="diaConfirmBtn_edit"
    >
      <div>
        <div class="glo_dialogForm">
          <el-form
            v-if="isShowDialog_edit"
            class="diaForm"
            ref="dialogFormRef"
            :model="dialogFormEdit"
            label-width="100px"
          >
            <el-form-item
              class="dialogFormItems"
              prop="itemCategoryId"
              label="费项类型:"
            >
              <el-select
                clearable
                filterable
                v-model="dialogFormEdit.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryId_edit"
              >
                <el-option
                  v-for="item in categoryNameList"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="itemCategoryId"
              label="费项类型:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogFormEdit.itemServiceId"
                placeholder="请选择"
                @change="changeItemServiceId_edit"
              >
                <el-option
                  v-for="item in CategoryServiceList"
                  :key="item.itemServiceId"
                  :label="item.title"
                  :value="item.itemServiceId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="dialogFormItems" prop="amount" label="金额:">
              <el-input
                type="number"
                v-model="dialogFormEdit.amount"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dislogFormTextarea"
              prop="remarks"
              label="备注:"
            >
              <el-input
                type="textarea"
                rows="2"
                v-model="dialogFormEdit.remarks"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
export default {
  components: { myDialog },
  props: {
    isShowDialog_otherFee: {
      typeof: Boolean,
      default: false,
    },
    diaWidth_otherFee: {
      typeof: String,
      default: "80%",
    },
    dialogTitle_otherFee: {
      typeof: String,
      default: "其他费用",
    },
    otherFeeReqs: {
      typeof: Array,
      default: [],
    },
  },
  data() {
    return {
      categoryNameList: [],
      CategoryServiceList: [],
      tablerData: [],
      DELlist: [],
      dialogForm: {
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
        operationType: "ADD",
      },

      diaWidth_edit: "40%",
      dialogTitle_edit: "修改费项",
      isShowDialog_edit: false,
      dialogFormEdit: {
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
        operationType: "",
      },
      editIdx: "",
    };
  },
  watch: {
    isShowDialog_otherFee: function (a, b) {
      if (a) {
        this.itemCategorChoose();
      }
    },
    otherFeeReqs: {
      handler(a, b) {
        this.tablerData = a || [];
        if (a.length == 0) {
          this.DELlist = [];
        }
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    editFee(idx) {
      let datas = JSON.parse(JSON.stringify(this.tablerData));
      this.dialogFormEdit = datas[idx];

      this.isShowDialog_edit = true;
      this.editIdx = idx;
      this.wtl_itemServiceListAll(this.dialogFormEdit.itemCategoryId);
    },
    delBtns(idx) {
      this.$confirm("是否删除该费项?", "提示:")
        .then(() => {
          let datas = JSON.parse(JSON.stringify(this.tablerData));
          if (datas[idx].operationType != "ADD") {
            datas[idx].operationType = "DEL";
            this.DELlist.push(datas[idx]);
          }
          datas.splice(idx, 1);
          this.tablerData = datas;
        })
        .catch(() => {});
    },
    handleCloseDia_edit() {
      this.isShowDialog_edit = false;
      this.editIdx = "";
      this.dialogFormEdit = {
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
        operationType: "",
      };
    },
    diaConfirmBtn_edit() {
      let datas = JSON.parse(JSON.stringify(this.tablerData));
      datas[this.editIdx] = this.dialogFormEdit;
      this.tablerData = datas;
      this.isShowDialog_edit = false;
    },
    //选择费项类型(编辑)
    changeItemCategoryId_edit(e) {
      this.dialogFormEdit.itemServiceId = "";
      this.dialogFormEdit.amount = "";
      this.dialogFormEdit.itemServiceName = "";
      if (e) {
        this.wtl_itemServiceListAll(e);
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogFormEdit.itemCategoryName = item.categoryName;
          }
        });
      }
    },
    //选择费项(编辑)
    changeItemServiceId_edit(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogFormEdit.amount = item.unitPrice;
            this.dialogFormEdit.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogFormEdit.amount = "";
        this.dialogFormEdit.itemServiceName = "";
      }
    },

    // 其他费用关闭
    handleCloseDia_otherFee() {
      this.$emit("handleCloseDia_otherFee");
      this.dialogForm = {
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
        operationType: "ADD",
      };
      //   this.tablerData = [];
    },
    // 确定保存
    diaConfirmBtn_otherFee() {
      let data = [...this.tablerData, ...this.DELlist];
      this.$emit("diaConfirmBtn_otherFee", data);
    },

    // 费型类型下拉列表
    itemCategorChoose() {
      this.$API.itemCategorChoose().then((res) => {
        this.categoryNameList = res.data.result || [];
      });
    },
    //选择费项类型()
    changeItemCategoryId(e) {
      this.dialogForm.itemServiceId = "";
      this.dialogForm.amount = "";
      this.dialogForm.itemServiceName = "";
      if (e) {
        this.wtl_itemServiceListAll(e);
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm.itemCategoryName = item.categoryName;
          }
        });
      }
    },

    //选择费项
    changeItemServiceId(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm.amount = item.unitPrice;
            this.dialogForm.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },

    // 添加费项
    confirmAdd() {
      let datas = JSON.parse(JSON.stringify(this.dialogForm));
      datas.operationType = "ADD";
      if (!datas.itemServiceId) {
        this.$message.error("请选择费项");
        return false;
      }

      for (var i = 0; i < this.tablerData.length; i++) {
        if (this.tablerData[i].itemServiceId == datas.itemServiceId) {
          this.$message.error("该费项已存在");
          return false;
        }
      }

      this.tablerData.push(datas);
    },
  },
};
</script>
<style scoped lang='less'>
.dialogFormItems {
  width: 100%;

  /deep/ .el-select {
    width: 100% !important;
  }
}
</style>